const NAVIGATE_BACK_FROM_KEY = 'navigateBackFrom';

const getFallbackPathname = (fallbackTo) => {
  if (typeof fallbackTo === 'string') {
    return fallbackTo.split('?')[0];
  }

  return fallbackTo?.pathname || '';
};

export const saveNavigateBackFrom = (location) => {
  if (!location?.pathname) {
    return;
  }

  sessionStorage.setItem(
    NAVIGATE_BACK_FROM_KEY,
    JSON.stringify({
      pathname: location.pathname,
      search: location.search || '',
    })
  );
};

const getSavedNavigateBackFrom = () => {
  try {
    return JSON.parse(sessionStorage.getItem(NAVIGATE_BACK_FROM_KEY) || 'null');
  } catch {
    return null;
  }
};

export const navigateBack = (navigate, fallbackTo, fallbackOptions) => {
  const savedFrom = getSavedNavigateBackFrom();
  const fallbackPathname = getFallbackPathname(fallbackTo);

  if (savedFrom?.pathname && savedFrom.pathname === fallbackPathname) {
    navigate(`${savedFrom.pathname}${savedFrom.search || ''}`, fallbackOptions);
    return;
  }

  if (typeof fallbackTo === 'string' && fallbackTo.includes('?')) {
    navigate(fallbackTo, fallbackOptions);
    return;
  }

  if (window.history.state?.idx === 0) {
    navigate(fallbackTo, fallbackOptions);
  } else {
    navigate(-1);
  }
};
